import type { Persona, ResearchRoomMessage } from '@repo/contracts';

import { summarisePoll } from './poll-summary';

/**
 * What Floto would ask next, for the composer's lightbulb: the
 * suggestions from the latest round's read — Floto's read of an open
 * question, the follow-ups a poll's votes call for, or the opener's starters
 * before anything has been asked.
 *
 * Only the latest round's: ideas from two rounds ago answer a conversation
 * that has moved on. A round still being read has none yet.
 */
export function latestIdeas(
  messages: ResearchRoomMessage[],
  personas: Map<string, Persona>,
): string[] {
  for (let i = messages.length - 1; i >= 0; i--) {
    const message = messages[i]!;
    switch (message.kind) {
      case 'summary':
      case 'opener':
        return message.status === 'done'
          ? (message.suggestedQuestions ?? [])
          : [];
      case 'poll':
        return message.status === 'done' && message.poll
          ? summarisePoll(message.poll, personas).followUps
          : [];
      case 'question':
      case 'answer':
        // A round with no read: still running, or nobody answered.
        return [];
      default:
        continue;
    }
  }
  return [];
}
